// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"a94fbcdf8dd91f2a","996":"4e6360cc26a80675"}[chunkId] + ".css";
};